import type { RouteResources } from '@atlassian/react-resource-router';
import { MenuIdDashboards } from '@jira/navigation-apps__constants/src/MenuIdDashboards.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { legacyDashboardsEditRoute } from '@jira/router-routes__legacy-dashboards-edit-routes/src/legacyDashboardsEditRoute.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyDashboardsEditRouteEntry: JiraLegacyRoute<RouteResources> = createLegacyEntry(
	legacyDashboardsEditRoute,
	() => ({
		layout: globalLayout,

		navigation: {
			menuId: MenuIdDashboards,
		},

		entryPoint: () => pageEntryPoint,
	}),
);
